import {
  ApplicationContext,
  ApplicationContextState
} from '@/store/modules/application-context/types/application-context.types';
import { Store } from 'vuex';

export const applicationContextActions = {
  async setApplicationContext(
    store: Store<ApplicationContextState>,
    payload: ApplicationContext
  ) {
    try {
      store.commit('SET_APPLICATION_CONTEXT', payload);
    } catch (error) {
      store.commit('SET_APPLICATION_CONTEXT_ERROR', error);
    }
  }
};
